import { defineMessages } from './TypedIntl'

// Foundational shared messages. Hand-picked `shared` namespace (not the
// path-derived default) because these are referenced across every app. Leaf
// keys are unchanged so existing `sharedMessages.x` references keep working;
// the focalazy ids move from `Shared.*` to `shared.*` (see
// packages/localization/focalazy-key-map.json for the old→new mapping the
// history re-import uses).
export const sharedMessages = defineMessages('shared', [
  { id: 'apiError', defaultMessage: '' },
  { id: 'attachmentsTooManyFiles', defaultMessage: '' },
  { id: 'attachmentsTooLargeFile', defaultMessage: '' },
  { id: 'metadataRemoved', defaultMessage: '' },
  { id: 'metadataUnableToRemove', defaultMessage: '' },
  { id: 'unsupportedMimetype', defaultMessage: '' },
  { id: 'submit', defaultMessage: '' },
  { id: 'fieldRequired', defaultMessage: '' },
  { id: 'selectPlaceholder', defaultMessage: '' },
  { id: 'encryptionError', defaultMessage: '' },
  { id: 'send', defaultMessage: '' },
  { id: 'delete', defaultMessage: '' },
  { id: 'download', defaultMessage: '' },
  { id: 'showMore', defaultMessage: '' },
  { id: 'cancel', defaultMessage: '' },
  { id: 'ok', defaultMessage: '' },
  { id: 'bio', defaultMessage: '' },
  { id: 'partnerBio', defaultMessage: '' },
] as const)
